import { render, staticRenderFns } from "./cpt-dataV-scrollList-option.vue?vue&type=template&id=183808c6&scoped=true"
import script from "./cpt-dataV-scrollList-option.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-scrollList-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183808c6",
  null
  
)

export default component.exports